import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/all';
import { load as loadPageData } from './components/page-data.js';
import header from './components/header.js';
import accordion from './components/accordion.js';
import tabs from './components/tabs.js';
import testimonialSlider from './components/testimonial-slider.js';
import smoothScrollingAnchors from './components/smooth-scrolling-anchors.js';
import fieldNotesGrid from './components/field-notes-grid.js';
import { pageInitializers } from './pages/index.js';
import windowHorizontalResizeEvent from './behavior/window-horizontal-resize-event.js';

gsap.registerPlugin(ScrollToPlugin);

windowHorizontalResizeEvent.register();

$(function() {
    header.initialize();
    accordion.initialize();
    tabs.initialize();
    testimonialSlider.initialize();
    smoothScrollingAnchors.initialize();

    const pageData = loadPageData();

    fieldNotesGrid.initialize();

    const pageInitializer = pageInitializers.find((initializer) => (
        initializer.name === pageData.slug
    ));

    if (pageInitializer) {
        pageInitializer.initialize();
    }
});
